module.exports = __webpack_public_path__ + "img/telegram.93f712ec.svg";